import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserQuery from "../../stateQueries/User";
import AlertPopup from "../AlertPopup";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));

export default function DeleteGalleryModal({ galleryItem }) {
  const [open, setOpen] = React.useState(false);
  const queryClient = useQueryClient();

  const deleteGalleryMutation = useMutation({
    mutationFn: async (id) => {
      return UserQuery.CSEQuery.deleteGalleryImage(id);
    },
    onSuccess: (data) => {
      setTimeout(() => {
        queryClient.invalidateQueries(["gallery"]);
        setOpen(false);
      }, 2000);
    }
  });

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  const handleDelete = () => {
    deleteGalleryMutation.mutate(galleryItem.id);
  };

  return (
    <div>
      <IconButton onClick={handleToggleOpen} color="error">
        <DeleteIcon />
      </IconButton>

      {deleteGalleryMutation.isError && (
        <AlertPopup
          open={true}
          severity="error"
          message={
            deleteGalleryMutation.error?.response?.data?.message ||
            "Server Error"
          }
        />
      )}
      {deleteGalleryMutation.isSuccess && (
        <AlertPopup open={true} message={deleteGalleryMutation.data?.message} />
      )}

      <BootstrapDialog
        onClose={handleToggleOpen}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Delete Gallery Image
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleToggleOpen}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography>
            Are you sure you want to delete "{galleryItem?.title}"? This action
            cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleToggleOpen} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="error"
            disabled={deleteGalleryMutation.isLoading}
            startIcon={
              deleteGalleryMutation.isLoading ? (
                <CircularProgress size={20} />
              ) : (
                <DeleteIcon />
              )
            }
          >
            Delete
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
